<template>
	<div class="media">
		  <img class="mr-3"  alt="Generic placeholder image">
		  <div class="media-body">
		    <h5 class="mt-0">{{comment.title}}</h5>
		    {{comment.text}}
		  </div>
	</div>
</template>

<script>
    export default {
       props:{
	       comment: {
		      type: Object,
		      required: true
		    },
    	},
       // components: { draggable },
       data(){
        return{
			comment: {}
        }
       },
       methods:{

       }
     }
</script>
